// extracted by mini-css-extract-plugin
export var dividerLine = "_7d-3";
export var itemImage = "_7d-9";
export var lightDivider = "_7d-4";
export var modalContent = "_7d-5";
export var modalContentCompact = "_7d-6";
export var productCard = "_7d-a";
export var productImage = "_7d-b";
export var productImageCompact = "_7d-7";
export var productImagePlaceholder = "_7d-c";
export var productImagePlaceholderCompact = "_7d-8";
export var progressBarBackground = "_7d-1";
export var progressBarContainer = "_7d-0";
export var progressBarFill = "_7d-2";